import { Component, Input } from "@angular/core";
import { CustomModal } from "@modules/core/components/base-modals";
import { FiatTransaction } from "@models/transaction";
import { Provider } from "@models";
import { FiatWalletQrModalComponent } from "@modules/main/components/fiat-wallet-qr-modal/fiat-wallet-qr-modal.component";

@Component({
	selector: "fiat-deposit-confirm-modal",
	templateUrl: "./fiat-deposit-remind-modal.component.html",
	styleUrls: ["./fiat-deposit-remind-modal.component.scss"],
	standalone: false
})
export class FiatDepositRemindModalComponent extends CustomModal {
	@Input()
	public transaction: FiatTransaction = null;
	@Input()
	public provider: Provider = null;

	public constructor() {
		super();
	}

	public closeAll(): void {
		super.closeAll();
	}

	public onClickSubmit(): void {
		this.showFiatWalletQrModal();
	}

	public onClickCancelDeposit(): void {
		this.closeAll();
	}

	private showFiatWalletQrModal(): void {
		this.modalService
			.create(FiatWalletQrModalComponent, {
				transaction: this.transaction,
				provider: this.provider
			})
			.present();
	}

	public onClickBack(): void {
		this.close();
	}

	public close(): void {
		// TODO temp (I really sorry for that..), but it's only way to fast fix this complicated flow now..
		// TODO will be refactored and fixed in next 2-3 sprints (here https://bitpanda.atlassian.net/browse/FADW-1346)
		this.transaction.requested = false;
		super.close();
	}
}
